const Currency = {
  rupee: "\u20B9",
};

export default Currency;
